<div
  class="upload-container h-auto align-middle"
  appDnd
  (fileDropped)="onFileDropped($event)"
  (dragover)="dragOver = true"
  (fileDropped)="dragOver = false"
  (dragleave)="dragOver = false"
>
  <input
    type="file"
    class="accent"
    #fileDropRef
    id="fileDropRef"
    (click)="clearFileInputValue($event)"
    multiple
    (change)="fileBrowseHandler($event)"
  />
  <div>
    <h5>
      {{ "fileUpload.dropHere" | msg | async }}
    </h5>
    <button type="button" class="btn btn-danger text-white px-4 mt-3">
      <svg-icon
        class="icon-upload"
        [src]="'../../../assets/images/icons/upload.svg'"
      ></svg-icon>
    </button>
  </div>
</div>

<div
  class="upload-files-list justify-content-center justify-content-lg-start justify-content-xxl-start justify-content-xl-start"
>
  <app-file-icon
    *ngFor="let file of uploadedFiles"
    [documentInfo]="file"
    (onFileRemove)="removeFile(file)"
  ></app-file-icon>
</div>
